import { Platform } from "react-native";
import { t, tc } from "@/localization";

// Pure helpers for the links and files under the video (LinksEditor).

const FILE_TYPES = {
  pdf: "PDF",
  doc: "Word",
  docx: "Word",
  xls: "Excel",
  xlsx: "Excel",
  ppt: "PowerPoint",
  pptx: "PowerPoint",
  txt: tc("file type", "Text"),
  csv: "CSV",
  png: tc("file type", "Image"),
  jpg: tc("file type", "Image"),
  jpeg: tc("file type", "Image"),
  gif: tc("file type", "Image"),
  webp: tc("file type", "Image"),
};

export const ACCEPTED_FILE_TYPES =
  Platform.OS === "web"
    ? "image/*, application/msword, application/pdf, text/*, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    : "*/*";

export const fileNameOf = (url) => {
  const last =
    String(url || "")
      .split("?")[0]
      .split("/")
      .pop() || "";
  try {
    return decodeURIComponent(last);
  } catch (e) {
    return last;
  }
};

export const fileKindOf = (url) => {
  const ext = fileNameOf(url).split(".").pop()?.toLowerCase();
  return FILE_TYPES[ext] || (ext ? ext.toUpperCase() : tc("file type", "File"));
};

// "order_of-service.pdf" → "Order of service"
export const titleFromFileName = (name) => {
  const base = String(name || "")
    .replace(/\.[^.]+$/, "")
    .replace(/[-_]+/g, " ")
    .trim();
  return base ? base.charAt(0).toUpperCase() + base.slice(1) : t("Document");
};

export const displayAddress = (url) =>
  String(url || "")
    .replace(/^mailto:/i, "")
    .replace(/^https?:\/\//i, "")
    .replace(/^www\./i, "")
    .replace(/\/$/, "");

// Same rule as the event page (evt.live makeHref): emails become mailto:,
// addresses without a scheme open over http(s).
export const hrefOf = (url) => {
  const value = String(url || "").trim();
  if (/^[a-z][a-z0-9+.-]*:/i.test(value)) return value;
  if (value.includes("@") && !value.includes("/")) return `mailto:${value}`;
  return `https://${value}`;
};

export const validateLink = ({ title, url }) => {
  const errors = {};
  const value = String(url || "").trim();
  if (!String(title || "").trim())
    errors.title = t("Add the text guests will see.");
  if (!value) errors.url = t("Add the web address.");
  else if (
    /\s/.test(value) ||
    !(
      /^[a-z][a-z0-9+.-]*:\S+/i.test(value) ||
      /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(value) ||
      /^[^\s/@]+\.[^\s/]{2,}/i.test(value)
    )
  ) {
    errors.url = t("Enter an address like zola.com/registry or an email.");
  }
  return errors;
};
